<template>
  <div>
    <header-component />
    <div class="main_banner">
      <!-- <img src="@/assets/images/news/bg_news.jpg" alt /> -->
      <b-img fluid :src="require('@/assets/images/news/bg_news.jpg')"></b-img>
    </div>
    <div class="news_cont">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="4" md="12" sm="12">
            <div class="right_side">
              <nav-list />
              <estimator />
            </div>
          </b-col>
          <b-col cols="12" lg="8" md="12" sm="12">
            <div class="left_side">
              <h4 class="mb-4">News</h4>
              <b-card v-for="item in newsItems" :key="item.index"
                :img-src="item.src"
                :img-alt="item.alt"
                img-left
                class="mb-3"
              >
                <h4>{{item.alt}}</h4>
                <p>
                  {{item.content}}
                </p>
                <b-link :to="item.link">Read More >></b-link>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";
import estimator from "@/components/estimator.vue";
import navList from "@/views/news/navlist.vue"

export default {
  components: {
    headerComponent,
    footerComponent,
    estimator,
    navList
  },
  data () {
    return {
      newsItems: [
        {
          src: require('@/assets/images/news/news1.jpg'),
          alt: "Tips on Saving Money",
          content: `Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua.`,
          link: "/news"
        },
        {
          src: require('@/assets/images/news/new2.jpg'),
          alt: "Financial Freedom",
          content: `Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua.`,
          link: "/news"
        },
        {
          src: require('@/assets/images/news/new3.jpg'),
          alt: "Zero Interest",
          content: `Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua.`,
          link: "/news"
        },
        {
          src: require('@/assets/images/news/new4.jpg'),
          alt: "How To Repay Loan?",
          content: `Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua.`,
          link: "/news"
        },
      ]
    }
  },
  beforeMount() {
    window.scrollTo(0, 0);
  }  
};
</script>

<style>
.loan_form .estimator_signin {
  margin-top: 75px;
}
</style>
<style lang="scss">
.news_cont {
  padding: 80px 0 120px;
  .left_side {
    padding-left: 30px;
    .card {
      border-radius: 4px;
      .card-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: $bg-lightgray;
        h4 {
          font-weight: 600;
        }
      }
    }
  }
}
@media (max-width: 992px) {
  .news_cont {
    .left_side {
      padding-left: 0;
      margin-top: 30px;
    }
  }
}
@media (max-width: 720px) {
  .news_cont .left_side .card {
    flex-direction: column !important;
  }
}
</style>